// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-wrapper[data-v-b76a3c46] {
  background-color: var(--bg-color-video-cont);
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}
.video-wrapper .share[data-v-b76a3c46] {
  margin: auto;
}
.video-wrapper .active[data-v-b76a3c46] {
  display: none;
  position: relative;
}
.video-wrapper .active .grid-wrapper[data-v-b76a3c46] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
}
.video-wrapper .active .grid-wrapper .grid-item[data-v-b76a3c46] {
  margin: auto;
}
.video-wrapper[data-v-b76a3c46] .videos-list {
  width: 100%;
  position: relative;
  flex: 1;
}
.video-wrapper[data-v-b76a3c46] .videos-list .remote {
  width: 100%;
}
.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout {
  height: 100%;
}
.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class {
  width: 100%;
  height: 100%;
}
.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class .videocontainer {
  display: block;
  height: initial !important;
  width: initial !important;
  overflow: hidden;
}
.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class .videocontainer video {
  height: 100% !important;
  width: 100%;
  object-fit: cover;
}
.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class .videocontainer .nick,
.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class .videocontainer .view_dummy {
  display: none;
}
.video-wrapper[data-v-b76a3c46] .videos-list .remote .placeholders_class {
  display: none;
}
.video-wrapper[data-v-b76a3c46] .videos-list .members-grid {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.video-wrapper.schema-puzzle[data-v-b76a3c46] {
  display: flex;
}
.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list {
  max-height: 100%;
  display: flex;
  margin: auto;
}
.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list .remote .videos_class {
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(var(--puzzle-columns), 1fr);
  grid-template-rows: repeat(var(--puzzle-rows), minmax(0, 1fr));
}
.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer.view_self {
  grid-column: 1;
  grid-row: 1;
}
.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list .members-grid {
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(var(--puzzle-columns), 1fr);
  grid-template-rows: repeat(var(--puzzle-rows), minmax(0, 1fr));
}
.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list .members-grid .own-item {
  grid-column: 1;
  grid-row: 1;
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .active {
  display: flex;
  width: 100%;
  height: 70%;
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .active canvas {
  margin: auto;
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list {
  position: relative;
  width: 100%;
  height: 30%;
  overflow-x: auto;
  overflow-y: hidden;
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .remote {
  height: 100%;
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .remote .videos_class {
  display: flex;
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer {
  flex: 0 0 calc(100% /3);
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer.view_self {
  order: -1;
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .members-grid {
  display: flex;
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .members-grid > * {
  flex: 0 0 calc(100% /3);
}
.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .members-grid .own-item {
  order: -1;
}
.video-wrapper.schema-share[data-v-b76a3c46] {
  display: flex;
  flex-direction: row;
}
.video-wrapper.schema-share[data-v-b76a3c46] .videos-list {
  position: relative;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 0 0 25%;
  min-width: 150px;
  max-width: 300px;
}
.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .remote {
  height: 100%;
}
.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .remote .videos_class {
  display: flex;
  flex-direction: column;
}
.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer {
  flex: 0 0 calc(100% /4);
}
.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer.view_self {
  order: -1;
}
.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .members-grid {
  display: flex;
  flex-direction: column;
}
.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .members-grid > * {
  flex: 0 0 calc(100% /4);
}
.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .members-grid .own-item {
  order: -1;
}
.video-wrapper.schema-my-share[data-v-b76a3c46] {
  display: flex;
  flex-direction: row;
}
.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list {
  position: relative;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  min-width: 150px;
  max-width: 300px;
}
.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .remote {
  height: 100%;
}
.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .remote .videos_class {
  display: flex;
  flex-direction: column;
}
.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer {
  flex: 0 0 calc(100% /4);
}
.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer.view_self {
  order: -1;
}
.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .members-grid {
  display: flex;
  flex-direction: column;
}
.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .members-grid > * {
  flex: 0 0 calc(100% /4);
}
.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .members-grid .own-item {
  order: -1;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/videomostMembersVideo.vue"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yDAAyD;EACzD,8DAA8D;AAChE;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yDAAyD;EACzD,8DAA8D;AAChE;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;AACX","sourcesContent":[".video-wrapper[data-v-b76a3c46] {\n  background-color: var(--bg-color-video-cont);\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.video-wrapper .share[data-v-b76a3c46] {\n  margin: auto;\n}\n.video-wrapper .active[data-v-b76a3c46] {\n  display: none;\n  position: relative;\n}\n.video-wrapper .active .grid-wrapper[data-v-b76a3c46] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n}\n.video-wrapper .active .grid-wrapper .grid-item[data-v-b76a3c46] {\n  margin: auto;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list {\n  width: 100%;\n  position: relative;\n  flex: 1;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list .remote {\n  width: 100%;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout {\n  height: 100%;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class {\n  width: 100%;\n  height: 100%;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class .videocontainer {\n  display: block;\n  height: initial !important;\n  width: initial !important;\n  overflow: hidden;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class .videocontainer video {\n  height: 100% !important;\n  width: 100%;\n  object-fit: cover;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class .videocontainer .nick,\n.video-wrapper[data-v-b76a3c46] .videos-list .remote .remotes_layout .videos_class .videocontainer .view_dummy {\n  display: none;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list .remote .placeholders_class {\n  display: none;\n}\n.video-wrapper[data-v-b76a3c46] .videos-list .members-grid {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.video-wrapper.schema-puzzle[data-v-b76a3c46] {\n  display: flex;\n}\n.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list {\n  max-height: 100%;\n  display: flex;\n  margin: auto;\n}\n.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list .remote .videos_class {\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: repeat(var(--puzzle-columns), 1fr);\n  grid-template-rows: repeat(var(--puzzle-rows), minmax(0, 1fr));\n}\n.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer.view_self {\n  grid-column: 1;\n  grid-row: 1;\n}\n.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list .members-grid {\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: repeat(var(--puzzle-columns), 1fr);\n  grid-template-rows: repeat(var(--puzzle-rows), minmax(0, 1fr));\n}\n.video-wrapper.schema-puzzle[data-v-b76a3c46] .videos-list .members-grid .own-item {\n  grid-column: 1;\n  grid-row: 1;\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .active {\n  display: flex;\n  width: 100%;\n  height: 70%;\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .active canvas {\n  margin: auto;\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list {\n  position: relative;\n  width: 100%;\n  height: 30%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .remote {\n  height: 100%;\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .remote .videos_class {\n  display: flex;\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer {\n  flex: 0 0 calc(100% /3);\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer.view_self {\n  order: -1;\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .members-grid {\n  display: flex;\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .members-grid > * {\n  flex: 0 0 calc(100% /3);\n}\n.video-wrapper.schema-tribune[data-v-b76a3c46] .videos-list .members-grid .own-item {\n  order: -1;\n}\n.video-wrapper.schema-share[data-v-b76a3c46] {\n  display: flex;\n  flex-direction: row;\n}\n.video-wrapper.schema-share[data-v-b76a3c46] .videos-list {\n  position: relative;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  flex: 0 0 25%;\n  min-width: 150px;\n  max-width: 300px;\n}\n.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .remote {\n  height: 100%;\n}\n.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .remote .videos_class {\n  display: flex;\n  flex-direction: column;\n}\n.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer {\n  flex: 0 0 calc(100% /4);\n}\n.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer.view_self {\n  order: -1;\n}\n.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .members-grid {\n  display: flex;\n  flex-direction: column;\n}\n.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .members-grid > * {\n  flex: 0 0 calc(100% /4);\n}\n.video-wrapper.schema-share[data-v-b76a3c46] .videos-list .members-grid .own-item {\n  order: -1;\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] {\n  display: flex;\n  flex-direction: row;\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list {\n  position: relative;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  min-width: 150px;\n  max-width: 300px;\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .remote {\n  height: 100%;\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .remote .videos_class {\n  display: flex;\n  flex-direction: column;\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer {\n  flex: 0 0 calc(100% /4);\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .remote .videos_class .videocontainer.view_self {\n  order: -1;\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .members-grid {\n  display: flex;\n  flex-direction: column;\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .members-grid > * {\n  flex: 0 0 calc(100% /4);\n}\n.video-wrapper.schema-my-share[data-v-b76a3c46] .videos-list .members-grid .own-item {\n  order: -1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
